import React from 'react';
import { toast } from 'react-toastify';
import { useVibrancy } from '../VibrancyDashboardContext';
import { COMPARE_OPTIONS, PERIOD_LABELS } from '../vibrancyDashboardService';

/** VD-14 Compare banner — current period vs prior period selector. */
const CompareBanner: React.FC = () => {
    const { compareMode, timeframe, comparePeriod, setComparePeriod, setCompareMode } = useVibrancy();
    if (!compareMode || timeframe === 'monthly') return null;

    const options = COMPARE_OPTIONS[timeframe];

    return (
        <div className="d-flex align-items-center gap-3 px-3 py-2 mb-3 rounded-3 text-white"
            style={{ background: 'linear-gradient(135deg,#0a1f44 0%,#14336b 100%)' }}>
            <span className="fw-semibold" style={{ fontSize: 11.5, color: 'rgba(255,255,255,.6)' }}>Comparing:</span>
            <span className="fw-bold" style={{ fontSize: 13 }}>{PERIOD_LABELS[timeframe]}</span>
            <span style={{ fontSize: 11, color: 'rgba(255,255,255,.35)' }}>vs</span>
            <select className="form-select form-select-sm bg-transparent text-white border-secondary"
                style={{ width: 'auto', fontSize: 12 }}
                value={comparePeriod || options[0]}
                onChange={e => { setComparePeriod(e.target.value); toast.success('Comparison period updated ✔'); }}>
                {options.map(o => <option key={o} style={{ color: '#000' }}>{o}</option>)}
            </select>
            <button className="btn btn-sm btn-outline-light ms-auto" style={{ fontSize: 11 }}
                onClick={() => setCompareMode(false)}>✕ Exit Comparison</button>
        </div>
    );
};

export default CompareBanner;
